module.exports = __webpack_public_path__ + "static/media/Montserrat-Medium.d8478173.woff";